import React, { Component } from 'react';
import { Form, Input, Button } from 'antd';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import 'antd/dist/antd.css';
import './styles.css';

class LogIn extends Component {
    handleSubmit = values => {
        this.props.onLogIn(values);
    };

    render() {
        return (
            <Grid className="loginCont">
                <Form onFinish={this.handleSubmit} className="login-form">
                    <Row center="xs">
                        <Col xs={12}>
                            <Form.Item name="email" rules={[{ required: true, message: 'Por favor, ingresa tu email' }]}>
                                <Input className="login-input-email"
                                prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder="Email"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col xs={12}>
                            <Form.Item name="password" rules={[{ required: true, message: 'Por favor, ingresa tu contraseña' }]}>
                                <Input.Password className="login-input-password"
                                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                type="password"
                                placeholder="Contraseña"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col xs={12}>
                            <Form.Item style={{ textAlign: "center" }}>
                                <Button type="primary" htmlType="submit" className="login-form-button">
                                    Ingresar
                                </Button>
                                {/*<Button onClick={this.signup} style={{marginLeft: '25px'}} className="btn btn-success">Signup</Button>*/}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col xs={12} className="linkCont">
                            <a className="link" href="http://reservando.com.ar/">Contáctanos para agregar su restaurante</a>
                        </Col>
                    </Row>
                </Form>
            </Grid>
        );
      }
}

LogIn.propTypes = {
    onLogIn: PropTypes.func.isRequired,
};

export default LogIn;